import * as Ably from 'ably';

let client: Ably.Realtime | null = null;

/**
 * Lazily creates a single shared Ably realtime connection.
 * Returns null when no key is configured, so realtime is simply disabled.
 * Never call this from a render body, it must stay a singleton.
 */
export const getAblyClient = (): Ably.Realtime | null => {
	const key = process.env['REACT_APP_ABLY_KEY'];
	if (!key) return null;

	if (!client) {
		client = new Ably.Realtime({
			key,
			autoConnect: true,
			closeOnUnload: true,
		});

		// realtime is an enhancement, failures must stay silent for the user
		client.connection.on('failed', (stateChange) => {
			console.warn('[ably] connection failed', stateChange.reason);
		});

		client.connection.on('suspended', (stateChange) => {
			console.warn('[ably] connection suspended', stateChange.reason);
		});

		if (process.env['REACT_APP_ENV'] === 'development') {
			client.connection.on((stateChange) => {
				console.log(`[ably] connection ${stateChange.previous} -> ${stateChange.current}`, stateChange.reason ?? '');
			});
		}
	}

	return client;
};

export const closeAblyClient = (): void => {
	if (!client) return;

	client.close();
	client = null;
};
